import utils from 'utils';
import {useEffect, useState} from 'react';

export const HeaderUserMenu = (props: {
    onRefresh: () => void,
}) => {
    const [scaleMode, setScaleMode] = useState(7);
    const [showScale, setShowScale] = useState(false);
    const scaleModeList = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500];

    useEffect(() => {
        if (scaleMode >= scaleModeList.length) {
            setScaleMode(scaleModeList.length - 1);
        }

        if (scaleMode < 0) {
            setScaleMode(0);
        }

        const rootRef = document.getElementById('root');
        const scaleValue = scaleModeList[scaleMode];

        rootRef.style.transform = 'scale(' + scaleValue / 100 + ')';
        rootRef.style.width = (10000 / scaleValue) + 'dvw';
        rootRef.style.height = (10000 / scaleValue) + 'dvh';
    }, [scaleMode]);

    return <div className={cmpClass}>
        {
            props.onRefresh ?
                <div className={classMap.item}>
                    <a
                        className={classMap.iconRefresh}
                        onClick={() => props.onRefresh()}
                    ></a>
                </div> :
                <></>
        }
        <div
            className={classMap.item}
            onClick={() => setShowScale(!showScale)}
        >
            <span className={classMap.iconUser}></span>
            <span>Brusírna</span>
        </div>
        {/*<div className={classMap.item}>*/}
        {/*    <a className={classMap.iconLogout}></a>*/}
        {/*</div>*/}
        {
            showScale ?
                <>
                    <div
                        className={classMap.item}
                        onClick={() => setScaleMode(scaleMode + 1)}
                    >
                        <a className={classMap.iconZoomIn}></a>
                    </div>
                    <div
                        className={classMap.item}
                        onClick={() => setScaleMode(scaleMode - 1)}
                    >
                        <a className={classMap.iconZoomOut}></a>
                    </div>
                </> :
                <></>
        }
    </div>;
};

const cmpClass = 'header-user-menu';
const classMap = utils.generateClassMap(cmpClass, {
    item: 'item',
    iconLogout: 'icon iconfa-logout',
    iconUser: 'icon iconfas-user',
    iconZoomIn: 'icon iconfa-zoomIn',
    iconZoomOut: 'icon iconfa-zoomOut',
    iconRefresh: 'icon iconfa-refresh',
    hide: 'hide',
});
